var _defs, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileBankingQr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-dot-color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,26,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 178,
    width: 16,
    height: 16,
    transform: "rotate(0,26,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,26,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,26,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,26,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,26,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,42,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,42,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 274,
    width: 16,
    height: 16,
    transform: "rotate(0,42,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,42,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,58,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,58,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 178,
    width: 16,
    height: 16,
    transform: "rotate(0,58,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,58,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,58,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,58,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,58,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,58,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,74,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 178,
    width: 16,
    height: 16,
    transform: "rotate(0,74,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,74,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,74,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,74,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,90,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,90,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,90,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,90,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,90,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,90,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,106,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,106,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,106,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,106,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,106,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,106,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,122,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 178,
    width: 16,
    height: 16,
    transform: "rotate(0,122,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,122,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,122,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 274,
    width: 16,
    height: 16,
    transform: "rotate(0,122,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,122,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,122,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,138,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,138,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,138,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,138,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 274,
    width: 16,
    height: 16,
    transform: "rotate(0,138,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,138,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,138,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 34,
    width: 16,
    height: 16,
    transform: "rotate(0,154,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 82,
    width: 16,
    height: 16,
    transform: "rotate(0,154,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 114,
    width: 16,
    height: 16,
    transform: "rotate(0,154,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,154,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,154,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 178,
    width: 16,
    height: 16,
    transform: "rotate(0,154,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,154,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,154,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,154,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,154,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 354,
    width: 16,
    height: 16,
    transform: "rotate(0,154,362)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 386,
    width: 16,
    height: 16,
    transform: "rotate(0,154,394)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 402,
    width: 16,
    height: 16,
    transform: "rotate(0,154,410)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 434,
    width: 16,
    height: 16,
    transform: "rotate(0,154,442)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 18,
    width: 16,
    height: 16,
    transform: "rotate(0,170,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 50,
    width: 16,
    height: 16,
    transform: "rotate(0,170,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 82,
    width: 16,
    height: 16,
    transform: "rotate(0,170,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 130,
    width: 16,
    height: 16,
    transform: "rotate(0,170,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 178,
    width: 16,
    height: 16,
    transform: "rotate(0,170,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,170,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,170,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,170,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,170,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 354,
    width: 16,
    height: 16,
    transform: "rotate(0,170,362)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 370,
    width: 16,
    height: 16,
    transform: "rotate(0,170,378)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 386,
    width: 16,
    height: 16,
    transform: "rotate(0,170,394)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 402,
    width: 16,
    height: 16,
    transform: "rotate(0,170,410)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 450,
    width: 16,
    height: 16,
    transform: "rotate(0,170,458)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 466,
    width: 16,
    height: 16,
    transform: "rotate(0,170,474)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 50,
    width: 16,
    height: 16,
    transform: "rotate(0,186,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 66,
    width: 16,
    height: 16,
    transform: "rotate(0,186,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 98,
    width: 16,
    height: 16,
    transform: "rotate(0,186,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 114,
    width: 16,
    height: 16,
    transform: "rotate(0,186,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 130,
    width: 16,
    height: 16,
    transform: "rotate(0,186,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,186,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,186,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,186,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,186,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,186,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,186,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,186,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,186,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,186,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 354,
    width: 16,
    height: 16,
    transform: "rotate(0,186,362)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 418,
    width: 16,
    height: 16,
    transform: "rotate(0,186,426)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 434,
    width: 16,
    height: 16,
    transform: "rotate(0,186,442)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 466,
    width: 16,
    height: 16,
    transform: "rotate(0,186,474)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 18,
    width: 16,
    height: 16,
    transform: "rotate(0,202,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 34,
    width: 16,
    height: 16,
    transform: "rotate(0,202,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 66,
    width: 16,
    height: 16,
    transform: "rotate(0,202,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 82,
    width: 16,
    height: 16,
    transform: "rotate(0,202,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 98,
    width: 16,
    height: 16,
    transform: "rotate(0,202,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 130,
    width: 16,
    height: 16,
    transform: "rotate(0,202,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,202,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 178,
    width: 16,
    height: 16,
    transform: "rotate(0,202,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,202,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,202,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,202,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,202,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,202,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,202,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 354,
    width: 16,
    height: 16,
    transform: "rotate(0,202,362)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 450,
    width: 16,
    height: 16,
    transform: "rotate(0,202,458)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 466,
    width: 16,
    height: 16,
    transform: "rotate(0,202,474)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 114,
    width: 16,
    height: 16,
    transform: "rotate(0,218,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 130,
    width: 16,
    height: 16,
    transform: "rotate(0,218,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 178,
    width: 16,
    height: 16,
    transform: "rotate(0,218,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,218,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,218,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,218,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,218,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 386,
    width: 16,
    height: 16,
    transform: "rotate(0,218,394)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 418,
    width: 16,
    height: 16,
    transform: "rotate(0,218,426)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 466,
    width: 16,
    height: 16,
    transform: "rotate(0,218,474)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 18,
    width: 16,
    height: 16,
    transform: "rotate(0,234,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 34,
    width: 16,
    height: 16,
    transform: "rotate(0,234,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 66,
    width: 16,
    height: 16,
    transform: "rotate(0,234,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 82,
    width: 16,
    height: 16,
    transform: "rotate(0,234,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 98,
    width: 16,
    height: 16,
    transform: "rotate(0,234,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,234,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,234,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,234,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,234,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,234,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,234,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 370,
    width: 16,
    height: 16,
    transform: "rotate(0,234,378)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 402,
    width: 16,
    height: 16,
    transform: "rotate(0,234,410)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 434,
    width: 16,
    height: 16,
    transform: "rotate(0,234,442)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 466,
    width: 16,
    height: 16,
    transform: "rotate(0,234,474)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 66,
    width: 16,
    height: 16,
    transform: "rotate(0,250,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 114,
    width: 16,
    height: 16,
    transform: "rotate(0,250,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,250,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,250,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,250,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,250,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,250,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,250,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,250,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 354,
    width: 16,
    height: 16,
    transform: "rotate(0,250,362)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 370,
    width: 16,
    height: 16,
    transform: "rotate(0,250,378)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 402,
    width: 16,
    height: 16,
    transform: "rotate(0,250,410)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 466,
    width: 16,
    height: 16,
    transform: "rotate(0,250,474)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 34,
    width: 16,
    height: 16,
    transform: "rotate(0,266,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 50,
    width: 16,
    height: 16,
    transform: "rotate(0,266,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 66,
    width: 16,
    height: 16,
    transform: "rotate(0,266,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 82,
    width: 16,
    height: 16,
    transform: "rotate(0,266,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 130,
    width: 16,
    height: 16,
    transform: "rotate(0,266,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,266,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,266,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 178,
    width: 16,
    height: 16,
    transform: "rotate(0,266,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,266,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,266,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,266,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 274,
    width: 16,
    height: 16,
    transform: "rotate(0,266,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,266,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,266,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,266,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,266,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 386,
    width: 16,
    height: 16,
    transform: "rotate(0,266,394)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 418,
    width: 16,
    height: 16,
    transform: "rotate(0,266,426)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 450,
    width: 16,
    height: 16,
    transform: "rotate(0,266,458)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 466,
    width: 16,
    height: 16,
    transform: "rotate(0,266,474)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 98,
    width: 16,
    height: 16,
    transform: "rotate(0,282,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 114,
    width: 16,
    height: 16,
    transform: "rotate(0,282,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,282,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,282,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,282,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,282,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,282,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 354,
    width: 16,
    height: 16,
    transform: "rotate(0,282,362)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 450,
    width: 16,
    height: 16,
    transform: "rotate(0,282,458)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 18,
    width: 16,
    height: 16,
    transform: "rotate(0,298,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 34,
    width: 16,
    height: 16,
    transform: "rotate(0,298,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 50,
    width: 16,
    height: 16,
    transform: "rotate(0,298,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 82,
    width: 16,
    height: 16,
    transform: "rotate(0,298,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 98,
    width: 16,
    height: 16,
    transform: "rotate(0,298,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,298,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 178,
    width: 16,
    height: 16,
    transform: "rotate(0,298,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,298,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 274,
    width: 16,
    height: 16,
    transform: "rotate(0,298,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,298,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,298,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,298,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 370,
    width: 16,
    height: 16,
    transform: "rotate(0,298,378)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 386,
    width: 16,
    height: 16,
    transform: "rotate(0,298,394)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 402,
    width: 16,
    height: 16,
    transform: "rotate(0,298,410)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 466,
    width: 16,
    height: 16,
    transform: "rotate(0,298,474)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 98,
    width: 16,
    height: 16,
    transform: "rotate(0,314,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 114,
    width: 16,
    height: 16,
    transform: "rotate(0,314,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,314,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,314,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,314,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 274,
    width: 16,
    height: 16,
    transform: "rotate(0,314,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,314,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,314,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 386,
    width: 16,
    height: 16,
    transform: "rotate(0,314,394)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 402,
    width: 16,
    height: 16,
    transform: "rotate(0,314,410)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 418,
    width: 16,
    height: 16,
    transform: "rotate(0,314,426)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 434,
    width: 16,
    height: 16,
    transform: "rotate(0,314,442)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 466,
    width: 16,
    height: 16,
    transform: "rotate(0,314,474)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 50,
    width: 16,
    height: 16,
    transform: "rotate(0,330,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 66,
    width: 16,
    height: 16,
    transform: "rotate(0,330,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 82,
    width: 16,
    height: 16,
    transform: "rotate(0,330,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 98,
    width: 16,
    height: 16,
    transform: "rotate(0,330,106)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 130,
    width: 16,
    height: 16,
    transform: "rotate(0,330,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,330,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,330,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,330,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,330,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,330,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,330,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 386,
    width: 16,
    height: 16,
    transform: "rotate(0,330,394)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 418,
    width: 16,
    height: 16,
    transform: "rotate(0,330,426)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 466,
    width: 16,
    height: 16,
    transform: "rotate(0,330,474)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 18,
    width: 16,
    height: 16,
    transform: "rotate(0,346,26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 34,
    width: 16,
    height: 16,
    transform: "rotate(0,346,42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 50,
    width: 16,
    height: 16,
    transform: "rotate(0,346,58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 82,
    width: 16,
    height: 16,
    transform: "rotate(0,346,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 114,
    width: 16,
    height: 16,
    transform: "rotate(0,346,122)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 130,
    width: 16,
    height: 16,
    transform: "rotate(0,346,138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,346,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,346,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,346,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,346,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,346,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,346,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,346,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 354,
    width: 16,
    height: 16,
    transform: "rotate(0,346,362)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 370,
    width: 16,
    height: 16,
    transform: "rotate(0,346,378)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 386,
    width: 16,
    height: 16,
    transform: "rotate(0,346,394)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 402,
    width: 16,
    height: 16,
    transform: "rotate(0,346,410)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 418,
    width: 16,
    height: 16,
    transform: "rotate(0,346,426)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 466,
    width: 16,
    height: 16,
    transform: "rotate(0,346,474)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,362,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,362,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,362,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,362,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,362,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,362,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,362,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 402,
    width: 16,
    height: 16,
    transform: "rotate(0,362,410)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 434,
    width: 16,
    height: 16,
    transform: "rotate(0,362,442)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 450,
    width: 16,
    height: 16,
    transform: "rotate(0,362,458)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 466,
    width: 16,
    height: 16,
    transform: "rotate(0,362,474)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,378,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 178,
    width: 16,
    height: 16,
    transform: "rotate(0,378,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,378,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,378,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,378,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,378,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,378,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,378,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,378,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 370,
    width: 16,
    height: 16,
    transform: "rotate(0,378,378)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 402,
    width: 16,
    height: 16,
    transform: "rotate(0,378,410)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 466,
    width: 16,
    height: 16,
    transform: "rotate(0,378,474)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 178,
    width: 16,
    height: 16,
    transform: "rotate(0,394,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,394,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,394,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 274,
    width: 16,
    height: 16,
    transform: "rotate(0,394,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,394,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,394,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 402,
    width: 16,
    height: 16,
    transform: "rotate(0,394,410)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 418,
    width: 16,
    height: 16,
    transform: "rotate(0,394,426)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 450,
    width: 16,
    height: 16,
    transform: "rotate(0,394,458)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,410,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,410,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,410,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 226,
    width: 16,
    height: 16,
    transform: "rotate(0,410,234)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,410,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 274,
    width: 16,
    height: 16,
    transform: "rotate(0,410,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,410,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,410,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 354,
    width: 16,
    height: 16,
    transform: "rotate(0,410,362)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 370,
    width: 16,
    height: 16,
    transform: "rotate(0,410,378)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 386,
    width: 16,
    height: 16,
    transform: "rotate(0,410,394)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 402,
    width: 16,
    height: 16,
    transform: "rotate(0,410,410)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 450,
    width: 16,
    height: 16,
    transform: "rotate(0,410,458)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 466,
    width: 16,
    height: 16,
    transform: "rotate(0,410,474)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,426,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,426,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,426,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 386,
    width: 16,
    height: 16,
    transform: "rotate(0,426,394)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 450,
    width: 16,
    height: 16,
    transform: "rotate(0,426,458)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 178,
    width: 16,
    height: 16,
    transform: "rotate(0,442,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 210,
    width: 16,
    height: 16,
    transform: "rotate(0,442,218)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 242,
    width: 16,
    height: 16,
    transform: "rotate(0,442,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,442,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 306,
    width: 16,
    height: 16,
    transform: "rotate(0,442,314)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 322,
    width: 16,
    height: 16,
    transform: "rotate(0,442,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,442,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 354,
    width: 16,
    height: 16,
    transform: "rotate(0,442,362)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 434,
    width: 16,
    height: 16,
    transform: "rotate(0,442,442)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 450,
    width: 16,
    height: 16,
    transform: "rotate(0,442,458)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 466,
    width: 16,
    height: 16,
    transform: "rotate(0,442,474)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 146,
    width: 16,
    height: 16,
    transform: "rotate(0,458,154)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,458,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 178,
    width: 16,
    height: 16,
    transform: "rotate(0,458,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 258,
    width: 16,
    height: 16,
    transform: "rotate(0,458,266)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 274,
    width: 16,
    height: 16,
    transform: "rotate(0,458,282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,458,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,458,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 386,
    width: 16,
    height: 16,
    transform: "rotate(0,458,394)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 450,
    width: 16,
    height: 16,
    transform: "rotate(0,458,458)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 466,
    width: 16,
    height: 16,
    transform: "rotate(0,458,474)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 162,
    width: 16,
    height: 16,
    transform: "rotate(0,474,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 178,
    width: 16,
    height: 16,
    transform: "rotate(0,474,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 194,
    width: 16,
    height: 16,
    transform: "rotate(0,474,202)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 290,
    width: 16,
    height: 16,
    transform: "rotate(0,474,298)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 338,
    width: 16,
    height: 16,
    transform: "rotate(0,474,346)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 370,
    width: 16,
    height: 16,
    transform: "rotate(0,474,378)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 402,
    width: 16,
    height: 16,
    transform: "rotate(0,474,410)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 450,
    width: 16,
    height: 16,
    transform: "rotate(0,474,458)"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 18 18v 112h 112v -112zM 34 34h 80v 80h -80z",
    transform: "rotate(0,74,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 50,
    width: 48,
    height: 48,
    transform: "rotate(0,74,74)"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 370 18v 112h 112v -112zM 386 34h 80v 80h -80z",
    transform: "rotate(90,426,74)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 50,
    width: 48,
    height: 48,
    transform: "rotate(90,426,74)"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 18 370v 112h 112v -112zM 34 386h 80v 80h -80z",
    transform: "rotate(-90,74,426)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 402,
    width: 48,
    height: 48,
    transform: "rotate(-90,74,426)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    height: 500,
    width: 500,
    clipPath: "url('#clip-path-background-color')",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    height: 500,
    width: 500,
    clipPath: "url('#clip-path-dot-color')",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileBankingQr);
export default __webpack_public_path__ + "static/media/mobile-banking-qr.9a861aab8ce9fde0fb6a1c18a0dcbd93.svg";
export { ForwardRef as ReactComponent };